import React from 'react';
import { Line } from 'common/line';
import { Button, ButtonSize, ButtonStyle, ButtonType } from 'common/button';
import { RouteName, goToPage } from 'routes';
import { classnames } from 'helpers/utils';
import styles from './forgot-password-step.module.scss';

type ForgotPasswordStep2Props = {
  notifGoBack: () => void;
  email: string;
};

const ForgotPasswordStep2: React.FC<ForgotPasswordStep2Props> = ({
  notifGoBack,
  email,
}) => {
  const showContentView = () => (
    <>
      <div className={classnames('text__title1__gray800', 'mt-15')}>
        {' '}
        Check your email!
      </div>
      <div className={classnames('text__body__regular__medium__gray700')}>
        {/* eslint-disable-next-line max-len */}
        We’ve sent you instructions to reset your password to <b>{email}</b>.
      </div>

      <Button
        className={classnames(styles.backButton)}
        onClick={() => {
          goToPage(RouteName.SignIn);
        }}
        buttonSize={ButtonSize.Medium}
        buttonType={ButtonType.Submit}
      >
        Back to Login
      </Button>
      <Line />
      <div className={styles.footerCheck}>
        <p className="text__body__regular__small__gray700">
          Didn’t receive the email? Check your spam folder or make sure your
          email address is correct. If needed,{' '}
          <Button
            buttonSize={ButtonSize.Small}
            buttonStyle={ButtonStyle.PrimaryGhostLink}
            onClick={notifGoBack}
          >
            update it here.
          </Button>
        </p>
      </div>
    </>
  );

  return <>{showContentView()}</>;
};

export { ForgotPasswordStep2 };
